export const calculateTimeDifference = (webinarDateTime: string, currentDateTime: string) => {

  const webinarDate = new Date(webinarDateTime);
  const currentDate = new Date(currentDateTime);


  if (isNaN(webinarDate.getTime()) || isNaN(currentDate.getTime())) {
    return null;
  }

  const differenceInMilliseconds = webinarDate.getTime() - currentDate.getTime();
  const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60)); // Convert ms to minutes

  return differenceInMinutes;
};

  export const formatWebinarDate = (dateString?: string) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null; 
  
    const dayOfWeek = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const day = new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const month = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const year = new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    const getOrdinal = (n: number) => {
      const s = ['th', 'st', 'nd', 'rd'],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };
  
    const formattedTime = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    }).format(date);
  
    return {
      dayOfWeek,
      day: getOrdinal(Number(day)),
      month,
      year,
      time: formattedTime,
    };
  };

  export   const getIndianTime = () => {
    const indianTime = new Date().toLocaleTimeString("en-US", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, 
    });
    return indianTime;
  };
  